<!--<template>
  <div class="marquee">
    <div class="marquee-content">
      <img
          v-for="logo in logos"
          :src="logo.src"
          :alt="logo.alt"
          :key="logo.id + '-1'"
          class="logo"
          :style="logo.id === 6 ? { padding: '30px 0', maxWidth: '250px' } : {}"
      />
      <img
          v-for="logo in logos"
          :src="logo.src"
          :alt="logo.alt"
          :key="logo.id + '-2'"
          class="logo"
          :style="logo.id === 6 ? { padding: '30px 0', maxWidth: '250px' } : {}"
      />
    </div>
  </div>
</template>-->
<template>
  <div class="marquee">
    <div class="marquee-content">
      <template v-for="n in 2">
        <img
            v-for="logo in logos"
            :key="`${logo.id}-${n}`"
            :src="logo.src"
            :alt="logo.alt"
            class="logo"
            :style="logo.id === 6 ? { padding: '30px 0', maxWidth: '250px' } : {}"
        />
      </template>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      logos: [
        {id: 1, src: './partners/aksa.png', alt: 'Logo 1'},
        {id: 2, src: './partners/mulag-logo.png', alt: 'Logo 3'},
        {id: 3, src: './partners/Aviogei.png', alt: 'Logo 3'},
        {id: 4, src: './partners/prekings.png', alt: 'Logo 12'},
        {id: 6, src: './partners/bertoli.png', alt: 'Logo 14'},
        {id: 7, src: './partners/dinobus.svg', alt: 'Logo 3'},
        {id: 8, src: './partners/fg-wilson.png', alt: 'Logo 8'},
        {id: 9, src: './partners/green-power.png', alt: 'Logo 9'},
        {id: 10, src: './partners/kohler-sdmo.png', alt: 'Logo 10'},
        {id: 11, src: './partners/mtu.png', alt: 'Logo 11'},
        {id: 12, src: './partners/prekings.png', alt: 'Logo 12'},
        {id: 13, src: './partners/teksan.png', alt: 'Logo 13'},
        {id: 14, src: './partners/boschung-logo.png', alt: 'Logo 3'},
        {id: 15, src: './partners/visa.png', alt: 'Logo 14'},
        {id: 16, src: './partners/mulag-logo.png', alt: 'Logo 3'},
        {id: 17, src: './partners/bertoli.png', alt: 'Logo 14'},
        {id: 18, src: './partners/emsa.png', alt: 'Logo 7'},
        {id: 19, src: './partners/boschung-logo.png', alt: 'Logo 3'},
      ]
    };
  },
}
</script>

<style>

.marquee {
  width: 100%;
  overflow: hidden;
  position: relative;
  margin-top: 50px;
  @include respond(phone) {
    margin-top: 0;
  }
}

.marquee-content {
  display: flex;
  min-width: fit-content;
  animation: marquee 30s linear infinite;
}

.logo {
  max-width: 150px;
  height: 125px;
  flex-shrink: 0;
  margin-right: 50px;
  @include respond(phone) {
    max-width: 130px !important;
    height: 115px !important;
    flex-shrink: 0;
    margin-right: 10px !important;
  }
  @include respond(from-phone-to-tab) {
    height: 100px;
  }
}
@keyframes marquee {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
}/* Mobile styles */
@media (max-width: 767px) {
  .marquee {
    margin-top: 20px;
  }

  .logo {
    max-width: 300px !important;
    height: 115px !important;
    flex-shrink: 0;
    margin-right: 10px !important;
  }

  .wide-logo {
    width: 180px;
    padding: 15px 0;
  }

  .marquee-content {
    animation-duration: 30s;
  }
}

/* Tablet styles */
@media (min-width: 768px) and (max-width: 1023px) {
  .logo {
    width: 120px;
    margin-right: 30px;
  }

  .wide-logo {
    width: 200px;
  }
}
</style>
